import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'pr-input-string-list',
  templateUrl: './pr-input-string-list.component.html',
  styleUrls: ['./pr-input-string-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrInputStringListComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class PrInputStringListComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() addLabel: string = 'Ajouter';
  @Input() derrors: boolean = false;

  values: string[] = [''];
  disabled: boolean = false;

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string[]): void {
    this.values = value && value.length ? [...value] : [''];
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  trackByIndex(index: number): number {
    return index;
  }

  labelFor(index: number): string {
    return index === 0 ? this.label : ' ';
  }

  update(index: number, value: string): void {
    this.values[index] = value;
    this.emit();
  }

  add(): void {
    this.values = [...this.values, ''];
    this.emit();
  }

  remove(index: number): void {
    this.values = this.values.filter((_, i) => i !== index);
    if (!this.values.length) {
      this.values = [''];
    }
    this.emit();
  }

  private emit(): void {
    this.onTouched();
    this.onChange(this.values.map(value => (value || '').trim()).filter(Boolean));
  }
}
